import { render, staticRenderFns } from "./convoList.vue?vue&type=template&id=dcbed4a0&scoped=true&"
import script from "./convoList.vue?vue&type=script&lang=js&"
export * from "./convoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbed4a0",
  null
  
)

export default component.exports